/*eslint-disable */
define(function (require) {
    'use strict';

    var Backbone = require('backbone');


    var EmployeeModel = Backbone.Model.extend({
        defaults: {
            employeeId: 0,
            employeeName: '',
            photoUri: ''
        },

        initialize: function (modelData) {
            // add id to model so collection can search
            this.set('id', modelData.employeeId)
        }
    });

    return EmployeeModel;
});
